import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const BoldText = styled('strong')``

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 0 96px;
    width: 100%;
  }
`
export const GridContainer = styled(({ margin, minHeight, padding, width, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  text-decoration: underline;
`
